/* ==============================================================
   Mana.jam — Aviso de estoque acabando (PDP)
   Web component <manajam-low-stock>.
   Lê o mapa variante→estoque renderizado pelo Liquid e atualiza a
   mensagem quando o cliente troca de variante (evento
   'variant:changed' do tema). Só mostra quando o estoque é
   gerenciado e está entre 1 e o limite configurado.
   ============================================================== */
(function () {
  if (window.customElements.get('manajam-low-stock')) return;

  class ManajamLowStock extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 5;
      this.message = this.dataset.message || 'Últimas [count] unidades em estoque!';
      this.messageOne = this.dataset.messageOne || 'Última unidade em estoque!';
      this.textEl = this.querySelector('[data-mnj-ls-text]');

      this.map = {};
      try {
        var dataEl = this.querySelector('[data-mnj-ls-data]');
        if (dataEl) this.map = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.map = {};
      }

      this.onVariantChanged = this.onVariantChanged.bind(this);
      document.addEventListener('variant:changed', this.onVariantChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariantChanged);
    }

    onVariantChanged(event) {
      var variant = event.detail && event.detail.variant;
      this.update(variant ? variant.id : null);
    }

    update(variantId) {
      var entry = variantId != null ? this.map[String(variantId)] : null;
      var show = !!(entry && entry.managed && entry.qty > 0 && entry.qty <= this.threshold);

      if (show && this.textEl) {
        this.textEl.textContent =
          entry.qty === 1 ? this.messageOne : this.message.replace('[count]', entry.qty);
      }
      this.hidden = !show;
    }
  }

  window.customElements.define('manajam-low-stock', ManajamLowStock);
})();
